import React, { useMemo } from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { getOfferDeadline } from '../utils/offer';
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

/**
 * Compact launch-offer countdown, sized to sit inside the pricing card between
 * the total value and the price of the day.
 */
export function CountdownTimer() {
  const deadline = useMemo(() => getOfferDeadline(), []);
  const {
    hours,
    minutes,
    seconds,
    isExpired
  } = useCountdown(deadline);
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Minutes'
  }, {
    value: seconds,
    label: 'Seconds'
  }];
  return <div className="mt-2.5 rounded-2xl border border-lavender-border bg-lavender px-4 py-3 text-center shadow-[0_10px_26px_-24px_rgba(74,58,107,0.7)]" data-id="element-30" data-mp="1aetq6oyh66f0">
      <p className="font-sans text-[9px] font-semibold uppercase tracking-[0.2em] text-champagne" data-id="element-31" data-mp="34r09yc5fpvix">
        Special launch offer
      </p>

      {isExpired ? <p className="mt-1.5 font-display text-base leading-snug text-plum" data-id="element-32" data-mp="1c0on2aegh9nk">
          Today’s launch price has ended.
        </p> : <>
          <p className="mt-1 font-display text-base leading-snug text-plum sm:text-lg" data-id="element-33" data-mp="1h0ji8q59klef">
            Your $27 launch price ends in
          </p>

          <div className="mt-2 flex items-start justify-center gap-1.5 sm:gap-3" aria-hidden="true" data-id="element-34" data-mp="171luvqjkqxx0">
            {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-35" data-mp="1ut9c1gr1aum3" data-mpi={index}>
                <div className="min-w-[3.25rem] rounded-xl border border-lavender-border bg-white px-2 py-1.5 sm:min-w-[3.75rem]" data-id="element-36" data-mp="1zqj0ou6ln28v">
                  <span className="block font-display text-2xl leading-none text-plum sm:text-3xl" data-id="element-37" data-mp="1l13b3hit12ur">
                    {pad(unit.value)}
                  </span>
                  <span className="mt-0.5 block font-sans text-[8px] font-semibold uppercase tracking-[0.14em] text-ash" data-id="element-38" data-mp="2dpse5m3f7i95">
                    {unit.label}
                  </span>
                </div>
                {index < units.length - 1 ? <span className="pt-1.5 font-display text-lg text-champagne" data-id="element-39" data-mp="2san1oz4dpdnl">
                    :
                  </span> : null}
              </React.Fragment>)}
          </div>
          <p className="sr-only" role="timer" data-id="element-40" data-mp="2jdw0k8ayz8m5">
            {hours} hours, {minutes} minutes and {seconds} seconds left at the
            launch price.
          </p>

          <p className="mx-auto mt-2 max-w-xs font-sans text-[10px] leading-snug text-ash" data-id="element-41" data-mp="29fg6pxkk5l8y">
            Complete 6-Volume System + all 7 Strategic Bonuses at today’s launch
            price.
          </p>
        </>}
    </div>;
}